import {
  getList,
  userLock,
  userActivate,
  getSingleUser,
  deleteUser,
  storeUser,
  updateUser,
} from '../../repository/users/index';

const state = {
  usersList: null,
  dialogVisibility: false,
  currentPage: 1,
  activeListItem: null,
  singleUser: null,
  postsPerPage: 10,
  totalPages: null,
  query: null,
  dirAccess: [],
};

const getters = {
  usersList: store => store.usersList,
  singleUser: store => store.singleUser,
  dialogVisibility: store => store.dialogVisibility,
  activeListItem: store => store.activeListItem,
  postsPerPage: store => store.postsPerPage,
  query: store => store.query,
  currentPage: store => store.currentPage,
  totalPages: store => store.totalPages,
  dirAccess: store => store.dirAccess,
};

const mutations = {
  SET_USERS_LIST(state, usersList) {
    state.usersList = usersList;
  },
  SET_TOTAL_PAGES(state, pages) {
    state.totalPages = pages;
  },
  SET_DIALOG_VISIBILITY(state, type) {
    state.dialogVisibility = type;
  },
  SET_ACTIVE_LIST_ITEM(state, id) {
    state.activeListItem = id;
  },
  SET_SINGLE_USER(state, user) {
    state.singleUser = user;
  },
  SET_QUERY(state, query) {
    state.query = query;
  },
  ADD_DIR_ACCESS(state, id) {
    if (!state.dirAccess.includes(id)) {
      state.dirAccess.push(id);
    }
  },
  REMOVE_DIR_ACCESS(state, id) {
    if (state.dirAccess.includes(id)) {
      const index = state.dirAccess.indexOf(id);
      state.dirAccess.splice(index, 1);
    }
  },
  CLEAR_DIR_ACCESS(state) {
    state.dirAccess = [];
  },
  SET_CURRENT_PAGE(state, page) {
    state.currentPage = page;
  },
};

const actions = {
  setCurrentPage({ commit }, page) {
    commit('SET_CURRENT_PAGE', page);
  },
  setQuery({ commit }, query) {
    commit('SET_QUERY', query);
  },
  async getUsersList({ commit, state }) {
    const { currentPage } = state;
    const defaultSort = {
      sort_by: 'name',
      sort_dir: 'asc',
    };
    const query = {
      ...defaultSort,
      ...state.query,
    };

    const params = {
      page: currentPage,
      length: state.postsPerPage,
      ...query,
    };
    commit('SET_USERS_LIST', null);
    let usersList = await getList(params);
    usersList = usersList.data.data;
    const { totalPages, items } = usersList;
    commit('SET_USERS_LIST', items);
    commit('SET_TOTAL_PAGES', totalPages);
  },
  addDirAccess({ commit }, id) {
    commit('ADD_DIR_ACCESS', id);
  },
  removeDirAccess({ commit }, id) {
    commit('REMOVE_DIR_ACCESS', id);
  },
  clearDirAccess({ commit }) {
    commit('CLEAR_DIR_ACCESS');
  },
  async lockUser({ dispatch }, id) {
    await userLock(id);
    await dispatch('getUsersList');
  },
  async activateUser({ dispatch }, id) {
    await userActivate(id);
    await dispatch('getUsersList');
  },
  async userDelete({ dispatch }, userData) {
    const { id, data } = userData;
    await deleteUser(id, data);
    await dispatch('getUsersList');
  },
  setDialogVisbility({ commit }, type) {
    commit('SET_DIALOG_VISIBILITY', type);
  },
  setActiveListItem({ commit }, id) {
    commit('SET_ACTIVE_LIST_ITEM', id);
  },
  async getSingleUser({ commit }, id) {
    commit('SET_SINGLE_USER', null);
    const getUser = await getSingleUser(id);
    const { user } = getUser.data.data;
    commit('SET_SINGLE_USER', user);
  },
  async storeNewUser({ dispatch }, userData) {
    await storeUser(userData);
    await dispatch('getUsersList');
  },
  async userUpdate({ dispatch }, userData) {
    await updateUser(userData.id, userData.data);
    await dispatch('getSingleUser', userData.id);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
